import { TFunction } from "i18next";

import { Feature } from "@sol/features";
import { Route } from "@sol/routing";
import { ExternalLink } from "@sol/uikit/core/icons/ExternalLink";
import { Plus } from "@sol/uikit/core/icons/Plus";

import { getLink, MenuItem } from "./getLink";

const TruncatedLabel = ({ children }: { children: string }) => {
    return (
        <span data-truncated-label className="block w-full min-w-0 truncate">
            {children}
        </span>
    );
};

export const getQuickActionItems = ({
    t,
    checkFeatureFlag,
}: {
    t: TFunction;
    checkFeatureFlag: (feature: Feature | Feature[]) => boolean;
}): MenuItem[] => {
    const items: MenuItem[] = [];

    if (checkFeatureFlag(Feature.MENU_QUICK_LINKS_BRIEF_CREATE)) {
        const label = t("component.Navigation.Menu.quickActionsMenu.items.brief");
        items.push(
            getLink({
                "data-cy": "menu-quick-action-brief",
                href: Route.BRIEFS_CREATE,
                label: <TruncatedLabel>{label}</TruncatedLabel>,
                tooltipTitle: label,
                icon: <Plus size={16} stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.MENU_QUICK_LINKS_PROFESSIONAL_SITUATION_CREATE)) {
        const label = t("component.Navigation.Menu.quickActionsMenu.items.professionalSituation");
        items.push(
            getLink({
                "data-cy": "menu-quick-action-professional-situation",
                href: Route.TRAINER_WORKSPACE_PROFESSIONAL_SITUATION_CREATE,
                label: <TruncatedLabel>{label}</TruncatedLabel>,
                tooltipTitle: label,
                icon: <Plus size={16} stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.USE_CLASSROOM_TEMPLATES)) {
        const label = t("component.Navigation.Menu.quickActionsMenu.items.classroomTemplate");
        items.push(
            getLink({
                "data-cy": "menu-quick-action-classroom-template",
                href: Route.CLASSROOM_TEMPLATE,
                label: <TruncatedLabel>{label}</TruncatedLabel>,
                tooltipTitle: label,
                icon: <Plus size={16} stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.CLASSROOM_CREATE)) {
        const label = t("component.Navigation.Menu.quickActionsMenu.items.classroom");
        items.push(
            getLink({
                "data-cy": "menu-quick-action-classroom",
                href: Route.CLASSROOMS_CREATE,
                label: <TruncatedLabel>{label}</TruncatedLabel>,
                tooltipTitle: label,
                icon: <Plus size={16} stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.ADMIN)) {
        const label = t("component.Navigation.Menu.quickActionsMenu.items.admin");
        items.push(
            getLink({
                "data-cy": "menu-quick-action-admin",
                href: Route.ADMIN,
                label: <TruncatedLabel>{label}</TruncatedLabel>,
                tooltipTitle: label,
                icon: <ExternalLink size={16} stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    return items;
};
